/**
 * @file src/components/VidButtonBank/FullScreenModal/FullScreenModal.tsx
 * @exports FullScreenModal
 * @summary Full-screen modal overlay used by the vID support button on mobile viewports.
 */

import { useSetAtom } from "jotai";
import { FC, useEffect } from "react";
import { modalOpenAtom } from "src/shame/shame-atoms";
import styled from "styled-components";

interface FullScreenModalProps {
	show?: boolean;
	children: React.ReactNode;
}

const ModalWrapper = styled.div<{ $show?: boolean }>`
  position: fixed;
  box-sizing: border-box;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: ${({ $show }) => ($show ? "block" : "none")};
  z-index: 99999;
  background: white;
`;

const FullScreenModal: FC<FullScreenModalProps> = ({ show, children }) => {
	const setModalOpen = useSetAtom(modalOpenAtom);
	useEffect(() => {
		if (show) {
			setModalOpen(true);
		} else {
			setModalOpen(false);
		}
		return () => setModalOpen(false);
	}, [show, setModalOpen]);

	return <ModalWrapper $show={show}>{children}</ModalWrapper>;
};

export default FullScreenModal;
